<script>
import modalUtilizeComponent from '@/components/modals/ready_utilize/ready_utilize.vue';
import productGroupComponent from '@/components/table_product_group/table_product_group.vue';

export default {
  data() {
    return {
      selected: [],
      rights: ['worker', 'admin'],
      filters: {
        search: '',
      },
      placeholder_text: 'Search by asin, product title, worker comment, client comment',
    };
  },
  components: {
    productGroup_component: productGroupComponent,
    modalUtilize_component: modalUtilizeComponent,
  },
  watch: {
    ready_for_utilize_list: {
      handler(list) {
        this.selected = list.map((item) => item.filter((subItem) => subItem.selected));
      },
      deep: true,
    },
  },
  computed: {
    ready_for_utilize_list() {
      return this.$store.state.readyForUtilize.ready_for_utilize_list;
    },

    loaded() {
      return this.$store.state.readyForUtilize.loaded;
    },

    user_role() {
      return this.$store.state.users.role;
    },

    isSelectedEmpty() {
      return this.selected.reduce((sum, cur) => sum + cur.length, 0);
    },

    modal_ready_for_utilize() {
      return this.$store.state.readyForUtilize.modal_ready_for_utilize;
    },
    app_section() {
      return this.$store.getters.get_app_section;
    },
    filteredProducts() {
      if (this.ready_for_utilize_list.length === 0) {
        return [];
      }

      return this.ready_for_utilize_list.filter((group) => {
        const asin = (group.filter((product) => (
          product.asin.toLowerCase().includes(this.filters.search.toLowerCase())
        ))).length > 0;

        const productTitle = (group.filter((product) => (
          product.title.toLowerCase().includes(this.filters.search.toLowerCase())
        ))).length > 0;

        const workerComment = (group.filter((product) => {
          if (product.worker_comment === null) return false;

          return product.worker_comment.toLowerCase().includes(this.filters.search.toLowerCase());
        })).length > 0;

        const clientComment = (group.filter((product) => {
          if (product.client_comment === null) return false;

          return product.client_comment.toLowerCase().includes(this.filters.search.toLowerCase());
        })).length > 0;

        return asin || productTitle || workerComment || clientComment;
      });
    },
  },
  created() {
    this.$store.dispatch('rfuset_loaded', false);
    this.$store.dispatch('rfuload_list');
  },
  methods: {
    show_modal() {
      this.$store.dispatch('rfuset_selected', this.selected);
    },
    set_search(str) {
      this.filters.search = str;
    },
    removeProductGroup(group) {
      const ids = this.getGroupIds(group);

      this.$store.commit('set_modal_inform', {
        type: 'delete',
        action: 'rfuremove_products',
        action_data: ids,
      });
    },
    removeProducts(product) {
      const ids = this.getProductsIds(product);

      let informMessage = {};
      informMessage[product.condition] = product.quantity;

      if (typeof product === 'undefined') {
        informMessage = {
          0: this.goodConditions,
          1: this.badConditions,
          2: this.attentionConditions,
        };
      }

      this.$store.commit('set_modal_inform', {
        type: 'delete',
        action: 'rfuremove_products',
        action_data: ids,
        informMessage,
      });
    },
    utilizeGroup(group) {
      const ids = this.getGroupIds(group);

      this.$store.commit('set_modal_inform', {
        type: 'inform',
        action: 'rfuutilize',
        action_data: ids,
        inform_message: 'utilize group of products',
      });
    },

    utilizeProduct(product) {
      const ids = this.getProductsIds(product);

      this.$store.commit('set_modal_inform', {
        type: 'inform',
        action: 'rfuutilize',
        action_data: ids,
        inform_message: 'utilize products',
      });
    },
    getGroupIds(group) {
      return group.reduce((acc, current) => {
        acc.push(...current.ids.map(Number));
        return acc;
      }, []);
    },
    getProductsIds(product) {
      return product.ids.reduce((acc, current) => {
        acc.push(Number(current));
        return acc;
      }, []);
    },
  },
};
</script>
<template src="./ready-for-utilize.pug" lang="pug"></template>
